import React, {useRef} from "react";
// import ReactHlsPlayer from 'react-hls-player';

export const HlsComponent = ({hlsUrl}) => {
    const ref = useRef();
    return <></>
}